import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from "vuex";
import { DELETE_NOTE, EDIT_NOTE, SEND_NOTE } from "@Broker/@Modules/clients/board/store/board-actions";
import ActivityConvertButton from "./convert-to-activity/activity-convert-button";
import HTMLTextEvaluationMixin from "@Shared/utils/application-mixins/html-text-evaluation-mixin";
import InlinePrompt from "@Shared/components/general/inline-prompt";
import ProfileAvatar from "@Shared/components/general/profile-avatar";
import RichTextEditor from "@Shared/utils/rich-text-editor";
import { showToast } from "@Shared/utils/constants";
import TimelineItemCard from "./utils/timeline-card.vue";
import TimelineCardFooter from "./utils/timeline-card-footer.vue";
import Err from "@Broker/@Routes/error";
import { CLIENT_PROFILE_CUSTOM_FIELDS_HINT_TAGS, CLIENT_PROFILE_CUSTOM_FIELDS_TAGS } from "../../../store/board-getters";
import HtmlIframePreview from "@Shared/components/general/html-iframe-preview.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "TimelineNote",
  components: {
    ActivityConvertButton,
    InlinePrompt,
    ProfileAvatar,
    TimelineItemCard,
    TimelineCardFooter,
    HtmlIframePreview
  },
  mixins: [HTMLTextEvaluationMixin],
  props: {
    creator: {
      type: Object,
      default: () => ({})
    },
    createdAt: {
      type: String,
      required: true
    },
    updatedAt: {
      type: String,
      required: true
    },
    notified: {
      type: Boolean
    },
    subscribers: {
      type: Array,
      default: () => []
    },
    pinned: {
      type: Boolean,
      default: false
    },
    activityType: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    note: {
      type: String,
      required: true
    },
    clientProfileId: {
      type: [String, Number],
      required: true
    },
    disabledActions: {
      type: Boolean,
      default: false
    },
    latestUpdate: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      sending: false,
      editing: false,
      noteDescription: this.note
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("BoardStore", [CLIENT_PROFILE_CUSTOM_FIELDS_TAGS, CLIENT_PROFILE_CUSTOM_FIELDS_HINT_TAGS])), {}, {
    disableSendToSubscriber() {
      return this.disabledActions || !this.subscribers.length;
    },
    canSave() {
      return this.htmlToTextContent(this.noteDescription) !== "";
    },
    name() {
      const {
        givenName,
        familyName
      } = this.creator;
      return this.$options.filters.nameFormat(givenName, familyName);
    },
    noteDescriptionHTML() {
      return RichTextEditor.sanitizeHtml(this.noteDescription);
    },
    customFieldsTags() {
      return this.CLIENT_PROFILE_CUSTOM_FIELDS_TAGS(this.clientProfileId);
    },
    customFieldsHintsTags() {
      return this.CLIENT_PROFILE_CUSTOM_FIELDS_HINT_TAGS(this.clientProfileId);
    }
  }),
  watch: {
    note(val) {
      this.noteDescription = val;
    },
    editing(val) {
      if (val) this.$nextTick(() => {
        this.init();
      });
    },
    customFieldsTags: {
      deep: true,
      handler(value) {
        var _this$editor;
        (_this$editor = this.editor) == null ? void 0 : _this$editor.updateOptions({
          mergeTags: defaults => {
            return [...defaults, ...value];
          }
        });
      }
    },
    customFieldsHintsTags: {
      deep: true,
      handler(value) {
        var _this$editor2;
        (_this$editor2 = this.editor) == null ? void 0 : _this$editor2.updateOptions({
          hints: defaults => {
            return [...defaults, ...value];
          }
        });
      }
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("BoardStore", [SEND_NOTE, EDIT_NOTE, DELETE_NOTE])), {}, {
    handlePin(id, type, pinned) {
      this.$emit("pin", id, type, pinned);
    },
    async sendToReferrers() {
      try {
        this.sending = true;
        await this.SEND_NOTE({
          id: this.clientProfileId,
          noteId: this.id
        });
        this.sending = false;
        showToast("success", "noteSentToSubscribers");
      } catch (e) {
        Err.handle(e);
      }
    },
    async handleDelete() {
      try {
        await this.DELETE_NOTE({
          id: this.clientProfileId,
          noteId: this.id
        });
        showToast("success", "noteDeleted");
      } catch (error) {
        Err.handle(error);
      }
    },
    editNote() {
      this.editing = true;
    },
    handleEdit() {
      this.editing = false;
      this.noteDescription = this.editor.getHTML();
      this.EDIT_NOTE({
        id: this.clientProfileId,
        noteId: this.id,
        data: {
          note: this.noteDescription
        }
      });
    },
    init() {
      const target = $(this.$refs.textarea);
      this.editor = new RichTextEditor(target, {
        airMode: true,
        height: "6vw",
        substitutionHints: true,
        showMergeTags: true,
        loadPreferences: false,
        mergeTags: defaults => {
          return [...defaults, ...this.customFieldsTags];
        },
        hints: defaults => {
          return [...defaults, ...this.customFieldsHintsTags];
        },
        callbacks: {
          onChange: this.handleEditorChange
        }
      });
    },
    handleEditorChange(_, content) {
      this.noteDescription = content;
    }
  })
});